var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A651",
    d: "M44.048 15L17 41.772 25.33 50 60 15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6CE39",
    d: "M5 30l20.495 20L33 42 20.707 30z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZD0iTTAgMGg2NHY2NEgweiIvPgogICAgPHBhdGggZmlsbD0iIzAwQTY1MSIgZD0iTTQ0LjA0OCAxNUwxNyA0MS43NzIgMjUuMzMgNTAgNjAgMTV6Ii8+CiAgICA8cGF0aCBmaWxsPSIjQTZDRTM5IiBkPSJNNSAzMGwyMC40OTUgMjBMMzMgNDIgMjAuNzA3IDMweiIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgWrike as ReactComponent };